module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', {
    attrs: {
      "grouped": "",
      "group-multiline": ""
    }
  }, [_c('div', {
    staticClass: "control"
  }, [_c('b-taglist', {
    attrs: {
      "attached": ""
    }
  }, [_c('b-tag', {
    attrs: {
      "type": "is-dark"
    }
  }, [_vm._v("npm")]), _vm._v(" "), _c('b-tag', {
    attrs: {
      "type": "is-info"
    }
  }, [_vm._v("0.5.1")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('b-taglist', {
    attrs: {
      "attached": ""
    }
  }, [_c('b-tag', {
    attrs: {
      "type": "is-dark"
    }
  }, [_vm._v("downloads")]), _vm._v(" "), _c('b-tag', {
    attrs: {
      "type": "is-success"
    }
  }, [_vm._v("15k")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('b-taglist', {
    attrs: {
      "attached": ""
    }
  }, [_c('b-tag', {
    attrs: {
      "type": "is-dark"
    }
  }, [_vm._v("chat")]), _vm._v(" "), _c('b-tag', {
    attrs: {
      "type": "is-primary"
    }
  }, [_vm._v("on discord")])], 1)], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b-field', {
    attrs: {
      "grouped": "",
      "group-multiline": ""
    }
  }, [_c('div', {
    staticClass: "control"
  }, [_c('b-tag', {
    attrs: {
      "type": "is-primary",
      "attached": "",
      "aria-close-label": "Close tag",
      "closable": ""
    }
  }, [_vm._v("\n                    Technology\n                ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('b-tag', {
    attrs: {
      "type": "is-primary",
      "attached": "",
      "aria-close-label": "Close tag",
      "closable": ""
    }
  }, [_vm._v("\n                    Vuejs\n                ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('b-tag', {
    attrs: {
      "type": "is-primary",
      "attached": "",
      "aria-close-label": "Close tag",
      "closable": ""
    }
  }, [_vm._v("\n                    CSS\n                ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('b-tag', {
    attrs: {
      "type": "is-primary",
      "attached": "",
      "aria-close-label": "Close tag",
      "closable": ""
    }
  }, [_vm._v("\n                    Flexbox\n                ")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a5fb6f2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/tag/examples/ExFieldCombine.vue
// module id = 1248
// module chunks = 16 182